import { DataSyncItem, OptimizelyProduct } from '../../types/DataSyncItem';
import { SyncStrategy } from '../../types/DataSyncItem';
import { DataSyncViewModel } from '../../types/DataSyncViewModel';

export class DataSyncStrategyProvider {
  public static getStrategy(dataSync: DataSyncItem | DataSyncViewModel) {
    if (dataSync.source.product === OptimizelyProduct.CMP) {
      return SyncStrategy.WEBHOOK;
    }
    return SyncStrategy.SCHEDULED;
  }
}
